.programme-card {
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-300);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  position: relative;
  text-decoration: none;
}

.programme-card--new::before {
  background-color: var(--color-purple-600);
  border-radius: 0.18rem 0 0 0.18rem;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 0.25rem;
  z-index: 1;
}

.programme-card:hover {
  background-color: var(--color-grey-200);
  border-color: var(--color-grey-600);
  cursor: pointer;
}

.programme-card__divider {
  border: none;
  border-top: 1px solid var(--color-grey-400);
  width: 100%;
}
